(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["donation-feed"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const donationFeedHeaderAmount = document.getElementById('donation-feed-header-amount');
  const donationFeedItems = document.querySelectorAll('.donation-feed-items li');

  donationFeedHeaderAmount.textContent = donationFeedItems.length;

// if the donation feed items are more than 3, show the footer
  if (donationFeedItems.length > 10) {
    donationFeedItems.forEach((item, index) => {
      if (index > 9) {
        item.style.display = 'none';
      }
    });
    document.querySelector('.donation-feed-footer').style.display = 'block';

    document.querySelector('.donation-feed-footer button').addEventListener('click', function() {
      donationFeedItems.forEach(item => {
        item.style.display = 'flex';
      });
      document.querySelector('.donation-feed-footer').style.display = 'none';
    });
  }
});
  } catch(e) { console.error(e); }
})();
})();
